import React, { useState } from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DOTTUYENSINH_API } from '@app/utils/apiUrl';
import { useMutation } from 'react-query';
import { Post } from '@app/utils/httpProvider';
import { DATE_TIME_REACT_WITHOUT_HOUR_FORMAT, messageError, messageToast, objectTrangThaiDotTuyenSinh, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { Button } from '@components';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';
import DatePicker from 'react-datepicker';
import Select from 'react-select';

const schema = yup.object().shape({
    maDot: yup.string().required(messageError.emptyMessage).max(50, 'Mã đợt tối đa 50 ký tự'),
    tenDot: yup.string().required(messageError.emptyMessage).max(255, 'Tên đợt tối đa 255 ký tự'),
    nam: yup.number().required(messageError.emptyMessage).min(1, 'Năm phải lớn hơn 0')
});

const DotTuyenSinhAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) => Post(DOTTUYENSINH_API.ADD_ITEM, null, value, false));

    const handleCreate = (values) => {
        setIsLoading(true);
        const model = {
            ...values
        };

        model.trangThaiDotTuyenSinh = values.trangThaiDotTuyenSinh.value;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(false);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.push(URI_INTERNAL.DOTTUYENSINH_PATH);
                }
            },
            onError: (res) => {
                toast.error(res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới đợt tuyển sinh</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        maDot: '',
                        tenDot: '',
                        nam: '',
                        tuNgay: '',
                        denNgay: '',
                        moTa: '',
                        trangThaiDotTuyenSinh: 0
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Mã đợt',
                                        name: 'maDot',
                                        value: values.maDot,
                                        onChange: handleChange,
                                        isInvalid: errors.maDot,
                                        error: errors.maDot,
                                        required: true
                                    },
                                    {
                                        label: 'Tên đợt',
                                        name: 'tenDot',
                                        value: values.tenDot,
                                        onChange: handleChange,
                                        isInvalid: errors.tenDot,
                                        error: errors.tenDot
                                    },
                                ]}
                            />


                            <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm={2}>Năm</Form.Label>
                                        <Col sm={10}>
                                            <Form.Control
                                                type="number"
                                                name="nam"
                                                value={values.nam}
                                                onChange={handleChange}
                                                isInvalid={!!errors.nam}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.nam}</Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Mô tả
                                        </Form.Label>
                                        <Col sm="10">
                                            <Col sm="10">
                                                <Editor
                                                    name="moTa"
                                                    value={values.moTa}
                                                    onChange={(value) => {
                                                        setFieldValue(
                                                            'moTa',
                                                            value
                                                        );
                                                    }}
                                                />
                                            </Col>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Từ ngày
                                        </Form.Label>
                                        <Col sm="9">
                                            <DatePicker
                                                locale="vi"
                                                selected={values.tuNgay}
                                                onChange={(date) => {
                                                    setFieldValue(
                                                        'tuNgay',
                                                        date,
                                                        true
                                                    );
                                                }}
                                                dateFormat={
                                                    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT
                                                }
                                                showMonthDropdown
                                                showYearDropdown
                                                // showMonthYearPicker
                                                // showFullMonthYearPicker
                                                className="form-control"
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Đến ngày
                                        </Form.Label>
                                        <Col sm="9">
                                            <DatePicker
                                                locale="vi"
                                                selected={values.denNgay}
                                                onChange={(date) => {
                                                    setFieldValue(
                                                        'denNgay',
                                                        date,
                                                        true
                                                    );
                                                }}
                                                dateFormat={
                                                    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT
                                                }
                                                showMonthDropdown
                                                showYearDropdown
                                                // showMonthYearPicker
                                                // showFullMonthYearPicker
                                                className="form-control"
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                             <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Trạng thái đợt tuyển sinh
                                        </Form.Label>
                                        <Col sm="9">
                                            <Select
                                                name="TrangThaiDotTuyenSinh"
                                                id="trangThaiDotTuyenSinh"
                                                placeholder="Trạng thái đăng ký dự tuyển"
                                                value={values.trangThaiDotTuyenSinh}
                                                onChange={(selectedOption) => {
                                                    const event = {
                                                        target: {
                                                            name: 'trangThaiDotTuyenSinh',
                                                            value: selectedOption
                                                        }
                                                    };
                                                    handleChange(event);
                                                }}
                                                options={objectTrangThaiDotTuyenSinh}
                                            />
                                            <div
                                                style={{
                                                    display: 'block',
                                                    color: '#dc3545'
                                                }}
                                                className="invalid-feedback"
                                            >
                                                {errors.trangThaiDotTuyenSinh}
                                            </div>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                </Col>
                            </Row>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>Thêm</Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.DOTTUYENSINH_PATH)} theme="secondary">Hủy</Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default DotTuyenSinhAdd;
